import type { ComponentType } from "react";
import When from "ui/support/When";
import NotAuthorized from "ui/molecules/NotAuthorized";
import type { AuthorizedProps } from "./types";
import useAuthorization from "features/auth/useAuthorization";

export const withAuthorization = <TProps extends Partial<AuthorizedProps>>(
    Component: ComponentType<TProps>,
    options?: AuthorizedProps
) => (props: TProps) => {
    const { isAuthorized } = useAuthorization();

    const {
        roles = [],
        fallback = (
            <NotAuthorized />
        )
    } = {
        ...options,
        ...props,
    };

    return (
        <When
            if={isAuthorized(roles)}
            then={(
                <Component
                    {...props}
                />
            )}
        >
            {fallback}
        </When>
    );
};

export default withAuthorization;
